import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/base';
import { Country } from '@shared/models';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

const COUNTRIES_CACHE_KEY = 'countries';
@Injectable({
  providedIn: 'root'
})
export class DictionariesApiService extends BaseApiService {
  private cache = new Map<string, any[]>();
  constructor(private http: HttpClient) {
    super();
  }

  public getCountries(): Observable<Country[]> {
    if (this.cache.has(COUNTRIES_CACHE_KEY)) {
      return of(this.cache.get(COUNTRIES_CACHE_KEY));
    }
    return this.http
      .get<Country[]>(`${this.queryBaseUrl}/countries`)
      .pipe(tap(data => this.cache.set(COUNTRIES_CACHE_KEY, data)));
  }
}
